"use client";

import { Box, Fade, Skeleton } from "@mui/material";
import { useAuthSession } from "@v2/hooks/useAuthSession";
import { DeviceViewport } from "@v2/types";
import CartButton from "./CartButton";
import ProfileButton from "./ProfileButton";

interface Props {
    viewport?: DeviceViewport;
}

export default function HeaderAuthArea({ viewport }: Props) {
    const { isReady } = useAuthSession();

    if (!isReady) {
        return (
            <Skeleton
                variant="rounded"
                sx={{ borderRadius: '6px', flexShrink: 0 }}
                width={92}
                height={36}
            />
        );
    }

    return (
        <Fade in>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CartButton />
                <ProfileButton viewport={viewport} />
            </Box>
        </Fade>
    );
}
